import { all, takeLatest } from 'redux-saga/effects';
import * as newSalesActions from '../actions';
import requestGetNewSales from './worker.requestGetNewSales';

function* newSalesSaga() {
  yield all([takeLatest([newSalesActions.requestGetNewSales.type], requestGetNewSales)]);
}

export default newSalesSaga;
